import { Component, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppConst } from '@shared/app-const';
import { IAppConfig } from 'src/app/app-config.interface';
import { AppConfigService } from 'src/app/app-config.service';

@Component({
  standalone: true,
  imports: [RouterOutlet],
  providers: [AppConfigService, { provide: LOCALE_ID, useValue: 'pt' }],
  selector: 'app-tesouraria',
  template: '<router-outlet></router-outlet>'
})
export class TesourariaComponent {
  public static configuraAppService(configPortalBakOffice:IAppConfig) {
    if(AppConfigService.config == undefined){
      AppConfigService.config = configPortalBakOffice
    }
  }

  public static configuraAppServiveSeForMDI() {
    const rmConfig = sessionStorage.getItem(AppConst.KEY_CONFIG);
    if (rmConfig) {
      const configParse = JSON.parse(rmConfig);
      const configAppService = {
        apiServer: configParse['api_baseUrl'],
        httpServer: configParse['http_baseUrl'] ? configParse['http_baseUrl'].split('/wwwroot/')[0] : configParse['api_baseUrl'],
        basePath: ''
      } as IAppConfig;
      TesourariaComponent.configuraAppService(configAppService);
    }
  }
}
